export const ACT_COMMON_LOG_CONFIG = {
    PID: '4_55',
    url: 'https://sp1.baidu.com/5b1ZeDe5KgQFm2e88IuM_a/webb.gif?',
};
